import React, { Component } from 'react';
import PropTypes from 'prop-types';
import getLabel from './../../../utils/labels'
import styles from './Timer.module.scss';

class Timer extends Component {
    render() {
        const { timeLeft } = this.props;

        let minute = ("0" + Math.floor(timeLeft / 60)).slice(-2);
        let second = ("0" + Math.floor(timeLeft % 60)).slice(-2);

        if (!(timeLeft >= 0)) {
            if (!window.location.href.includes('tutorial')) {
                return null;
            } else {
                minute = 0;
                second = 0;
            }
        }

        return (
            <div
                className={styles['timer-container']}
                style={(timeLeft < 300 && !window.location.href.includes('tutorial')) ? { backgroundColor: 'rgb(255, 74, 74)' } : {}}
                id="tutorial-timer"
            >
                <div className={styles['timer-content']}>
                    <div className={styles.minute}>
                        <div className={styles.bigtext} > {minute}</div>
                        <div className={styles.smalltext} >{getLabel('label_timer_mins')}</div>
                    </div>
                    <div className={styles.divider}> :</div>
                    <div className={styles.second}>
                        <div className={styles.bigtext} > {second} </div>
                        <div className={styles.smalltext} >{getLabel('label_timer_secs')}</div>
                    </div>
                </div>
            </div>
        )
    }
}

Timer.propTypes = {
    timeLeft: PropTypes.number
};

Timer.defaultProps = {
    timeLeft: -1
};

export default Timer;


// WEBPACK FOOTER //
// /src/components/header/timer/Timer.js